module.exports = function() {
  return new Worker(__webpack_public_path__ + "01911fcd0ea26d260a8e.worker.js");
};